import BaseComponent from './BaseComponent';

class MediaGallery extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.handlePagination();
        this.urlParams = new URLSearchParams();
        this.handleSearch(el);
        this.handleCheckboxes(el, 'file-types');
        this.handleCheckboxes(el, 'tags');
        this.handleOverlay();
    }

    handleSearch(el) {
        let typingTimer;
        let doneTypingInterval = 1200;
        let search = el.querySelector('#search');
        if (!search) {
            return;
        }
        const loadingIndicator = el.querySelector('#filebank-loading');
        const gridItems = el.querySelector('.grid__items');
        search.addEventListener('keyup', () => {
            let url = new URL(search.parentNode.action);
            url.searchParams.set(search.name, search.value);
            clearTimeout(typingTimer);
            typingTimer = setTimeout(function () {
                loadingIndicator.style.visibility = 'visible';
                gridItems.style.visibility = 'hidden';
                fetch(url)
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        loadingIndicator.style.visibility = 'hidden';
                        gridItems.style.visibility = 'visible';
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        gridItems.innerHTML = div.querySelector('.grid__items').innerHTML;
                        el.querySelector('#tags').innerHTML = div.querySelector('#tags').innerHTML;
                        const filterTags = el.querySelector('#filter-tags');
                        if (filterTags) {
                            filterTags.innerHTML = div.querySelector('#filter-tags').innerHTML;
                        }
                        el.querySelector('#file-types').innerHTML = div.querySelector('#file-types').innerHTML;
                        el.querySelector('#search-form').action = div.querySelector('#search-form').action;
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            }, doneTypingInterval);
        });
    }

    handleOverlay() {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('.file-teaser')) {
                return;
            }
            const modalSelector = document.querySelector('#filebank .modal__body');
            modalSelector.innerHTML = '';
            fetch(e.target.closest('.file-teaser').dataset.href)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    modalSelector.innerHTML = div.querySelector('.file-download').outerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
    handleCheckboxes(el, selector) {
        let checkboxes = this.el.querySelectorAll(`#${selector} input`);
        const loadingIndicator = el.querySelector('#filebank-loading');
        const gridItems = el.querySelector('.grid__items');
        checkboxes.forEach((checkbox) => {
            document.body.addEventListener('change', (e) => {
                if (checkbox.value !== e.target.value) {
                    return;
                }
                loadingIndicator.style.visibility = 'visible';
                gridItems.style.visibility = 'hidden';
                let href = '';
                if (e.target.checked) {
                    href = e.target.dataset.href;
                } else {
                    href = e.target.dataset.removeHref;
                }
                fetch(href)
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        loadingIndicator.style.visibility = 'hidden';
                        gridItems.style.visibility = 'visible';
                        gridItems.innerHTML = div.querySelector('.grid__items').innerHTML;
                        el.querySelector('#tags').innerHTML = div.querySelector('#tags').innerHTML;
                        const filterTags = el.querySelector('#filter-tags');
                        if (filterTags) {
                            filterTags.innerHTML = div.querySelector('#filter-tags').innerHTML;
                        }
                        el.querySelector('#file-types').innerHTML = div.querySelector('#file-types').innerHTML;
                        el.querySelector('#search-form').action = div.querySelector('#search-form').action;
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            });
        });
    }

    handlePagination() {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('#media-gallery-load-more')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            fetch(e.target.dataset.href)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    e.target.parentNode.outerHTML = div.querySelector('.grid__items').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
}

export default MediaGallery;
